import { Moon, Sun } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useUiStore } from '@stores/ui.store';

/** Dark/light theme toggle. */
export function ThemeToggle(): React.JSX.Element {
  const { t } = useTranslation();
  const theme = useUiStore((s) => s.theme);
  const toggleTheme = useUiStore((s) => s.toggleTheme);

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={t('nav.switchTheme')}
      title={t('nav.switchTheme')}
      className="inline-flex size-9 items-center justify-center rounded-full border border-[var(--btn-ghost-bd)] text-text transition-colors hover:bg-[var(--btn-ghost-hover)]"
    >
      {theme === 'dark' ? <Sun size={18} aria-hidden="true" /> : <Moon size={18} aria-hidden="true" />}
    </button>
  );
}
